export default __webpack_public_path__ + "ebd74a2817b71b3589704ecf52869df5.svg";